export default {"src":"/_next/static/media/heart_24.5a5b1a7e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};